// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"735":"bbffec3c","918":"cef87044"}[chunkId] + ".chunk.css";
};